export {
  primaryServiceBaseDuration,
  jobDurationHoursForScheduling,
} from './serviceDurationHelpers';
export { calculateServicePrices } from './calculateServicePrices';
export { calculatePriceWithEquipment } from './calculatePriceWithEquipment';
export { extractEquipmentAdjustments } from './extractEquipmentAdjustments';
export { mergeEquipmentWithOverrides } from './mergeEquipmentWithOverrides';
export { applyPriceOverrides } from './applyPriceOverrides';
export { annotateBundleMetadata } from './annotateBundleMetadata';
export {
  coveredServiceIds,
  bundleProgress,
  completingBundle,
  bestCompleteBundle,
} from './bundleCoverage';
export { usePriceCalculation } from './usePriceCalculation';
export type { UsePriceCalculationParams, UsePriceCalculationResult } from './usePriceCalculation';
export {
  serviceHasRequiredInfoModifiers,
  serviceHasPropertyDrivenModifiers,
  PROPERTY_BASIS_KEYS_FOR_REQUIRED_INFO,
  getChangedRequiredInfoFieldIds,
  serviceModifiersTouchRequiredInfoIds,
} from './requiredInfoModifierUtils';
export {
  recalculateChargesForRequiredInfo,
  recalculateChargesForPropertyChange,
  previewRequiredInfoPriceChange,
  previewPropertyPriceChange,
  computeTotalJobDurationHours,
} from './recalculateChargesForRequiredInfo';
export type {
  ChargeRecalculationUpdate,
  RequiredInfoPricePreview,
  AffectedChargeLinePreview,
  RecalculateChargesForRequiredInfoOptions,
} from './recalculateChargesForRequiredInfo';

